// extracted by mini-css-extract-plugin
module.exports = {"switcher":"styles_switcher__3XpZ8","switcherBg":"styles_switcherBg__1aVJr","overflow":"styles_overflow__1GIU0","button":"styles_button__z1n0W","active":"styles_active__3a_oo"};